module.exports = __webpack_public_path__ + "static/media/la-parrila-logo.b5be9ce0.png";